import { useTranslation } from 'react-i18next';

import { OpFlex } from 'new-components/DLS/OpFlex/OpFlex';
import { OpModal } from 'new-components/DLS/OpModal/OpModal';

import WarningIcon from '../../../../images/icons/warning.svg';

interface VisitorScreeningAlertModalProps {
  visible: boolean;
  onCancel: () => void;
  onViewDetails: () => void;
}

const VisitorScreeningAlertModal = ({
  visible,
  onCancel,
  onViewDetails,
}: VisitorScreeningAlertModalProps) => {
  const { t } = useTranslation();

  return (
    <OpModal
      title={t('visitors.redFlag.screeningAlert.title')}
      open={visible}
      onCancel={onCancel}
      onOk={onViewDetails}
      okText={t('visitors.redFlag.screeningAlert.viewDetails')}
      cancelText={t('visitors.redFlag.screeningAlert.cancel')}
      width={416}
    >
      <OpFlex gap={16} align="flex-start">
        <img
          src={WarningIcon}
          alt="Warning"
          style={{ width: 22, flexShrink: 0 }}
        />
        <div>
          <div>{t('visitors.redFlag.screeningAlert.message')}</div>
        </div>
      </OpFlex>
    </OpModal>
  );
};

export default VisitorScreeningAlertModal;
